import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './axiosBaseQuery';
import { accountApi } from './accountApi';
import {
  OnboardingStateResponse,
  OnboardingProfileResponse,
  OnboardingProfilePayload,
} from '../../../types/onboarding';

export const onboardingApi = createApi({
  reducerPath: 'onboardingApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Onboarding', 'OnboardingProfile'],
  endpoints: (builder) => ({
    getOnboardingState: builder.query<OnboardingStateResponse, void>({
      query: () => 'internal/v1/onboarding/state',
      providesTags: ['Onboarding'],
    }),
    getOnboardingProfile: builder.query<OnboardingProfileResponse, void>({
      query: () => 'internal/v1/onboarding/profile',
      providesTags: ['OnboardingProfile'],
    }),
    updateOnboardingProfile: builder.mutation<
      void,
      Partial<OnboardingProfilePayload>
    >({
      query: (data) => ({
        url: 'internal/v1/onboarding/profile',
        method: 'PATCH',
        data,
      }),
      invalidatesTags: ['OnboardingProfile'],
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(accountApi.util.invalidateTags(['Account']));
        } catch {
          // Failure is surfaced to the user in the modal; nothing to invalidate.
        }
      },
    }),
    trackEvent: builder.mutation<void, { event: string; stage?: string }>({
      query: (data) => ({
        url: 'internal/v1/track-event',
        method: 'POST',
        data,
      }),
    }),
  }),
});

export const {
  useGetOnboardingStateQuery,
  useGetOnboardingProfileQuery,
  useUpdateOnboardingProfileMutation,
  useTrackEventMutation,
} = onboardingApi;
